import React from 'react';
import classes from '../styles.module.css';
import formsClasses from '@app/styles/forms.module.css';
import cls from 'classnames';

type CEPHelperTextProps = {
  isFetching: boolean;
  hasErrorOnSearch: boolean;
  invalidCEPMessage: string;
};

export default function CEPHelperText({ isFetching, hasErrorOnSearch, invalidCEPMessage }: CEPHelperTextProps) {
  if (!isFetching && !hasErrorOnSearch && invalidCEPMessage.length === 0) return null;

  function getMessage() {
    if (isFetching) return 'Buscando...';
    if (hasErrorOnSearch) return 'Ocorreu um erro ao encontrar o CEP.';
    if (invalidCEPMessage.length > 0) return invalidCEPMessage;
    return '';
  }

  return (
    <span
      className={cls(
        Boolean(hasErrorOnSearch || invalidCEPMessage) && [classes.errorMessage, formsClasses.errorMessage],
        isFetching && classes.fetchingCep
      )}
    >
      {getMessage()}
    </span>
  );
}
